import React from "react";
import ProductDetail from "./ProductDetail";
import { products } from "../data/products";

const PhotoPrinterPage = () => <ProductDetail product={products.photoPrinter} />;

export default PhotoPrinterPage;
